var React = require('react');

function ArrowRightNoFill (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.7439 4.56695C14.8226 4.4989 14.8616 4.40923 14.8606 4.31982C14.8616 4.23042 14.8226 4.14075 14.7439 4.0727L10.1466 0.10086C9.99095 -0.03362 9.73756 -0.03362 9.5819 0.10086L9.14751 0.476147C8.99185 0.610626 8.99185 0.829546 9.14751 0.964026L12.3257 3.70982H0.398181C0.177367 3.70982 0 3.86306 0 4.05383V4.5855C0 4.77628 0.177367 4.92952 0.398181 4.92952H12.326L9.14751 7.67562C8.99185 7.8101 8.99185 8.02902 9.14751 8.1635L9.5819 8.53879C9.73756 8.67327 9.99095 8.67327 10.1466 8.53879L14.7439 4.56695Z"}));
}

ArrowRightNoFill.defaultProps = {"width":"15","height":"9","viewBox":"0 0 15 9","fill":"none"};

module.exports = ArrowRightNoFill;

ArrowRightNoFill.default = ArrowRightNoFill;
